import { DataBean } from "../DataBean";



export class BudgetResource extends DataBean {

    public async getBudgetResourceCatalog(idBudgetResource: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetResourceCatalog_Number", [idBudgetResource]);
    }

    public async getBudgetResourceForYear(date: any, budgetIDStr: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetResourceForYear_java.util.Date_String", [date, budgetIDStr]);
    }

    public async deleteBudgetResource(idBudgetResource: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteBudgetResource_Number", [idBudgetResource]);
    }
    public async deleteBudgetResource2(idBudgetResource: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteBudgetResource_Number", [idBudgetResource]);
    }

}